"use client";

import { useEffect } from "react";
import { isDatadogRumConfigured } from "@/lib/datadog/config";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (!isDatadogRumConfigured()) {
      return;
    }

    void import("@datadog/browser-rum-nextjs").then(({ addNextjsError }) => {
      addNextjsError(error);
    });
  }, [error]);

  return (
    <html lang="en">
      <body className="min-h-screen bg-gray-50 antialiased">
        <div className="container mx-auto px-4 py-6">
          <div className="mx-auto max-w-2xl rounded-lg border border-red-200 bg-red-50 p-6">
            <h1 className="text-2xl font-semibold text-red-900">Something went wrong</h1>
            <p className="mt-2 text-sm text-red-900">
              An unexpected error occurred in the application.
            </p>
            {error.digest ? (
              <p className="mt-2 text-xs text-red-800">
                Reference: <span className="font-mono">{error.digest}</span>
              </p>
            ) : null}
            <button
              type="button"
              onClick={reset}
              className="mt-4 rounded bg-red-700 px-3 py-2 text-sm font-medium text-white hover:bg-red-800"
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
